export var EScheduledExportFrequency;
(function (EScheduledExportFrequency) {
    EScheduledExportFrequency["Daily"] = "DAILY";
    EScheduledExportFrequency["Weekly"] = "WEEKLY";
    EScheduledExportFrequency["Monthly"] = "MONTHLY";
    EScheduledExportFrequency["Yearly"] = "YEARLY";
})(EScheduledExportFrequency || (EScheduledExportFrequency = {}));
// The run day of a monthly or yearly schedule that means "the last day of the month". A day the
// month lacks (31 in a 30-day month, 29 or 30 February) also runs on the month's last day.
export var LAST_DAY_OF_MONTH = -1;
export var MAX_DAY_OF_MONTH = 31;
// The most recurring exports one office may keep (MAX_SCHEDULED_EXPORTS_PER_ACCOUNT in
// rentio-api-next). The export screen loads them in one page of this size.
export var MAX_SCHEDULED_EXPORTS_PER_ACCOUNT = 20;
// ISO weekdays, as runDay of a weekly schedule: 1 is Monday, 7 is Sunday.
export var WEEKDAY_KEYS = [
    "system.monday",
    "system.tuesday",
    "system.wednesday",
    "system.thursday",
    "system.friday",
    "system.saturday",
    "system.sunday",
];
